var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[ 'Toggle', { 'Toggle-checked': this.checked } ],on:{"click":_vm.handleChange}},[_c('span',{class:[ 'thumb', { 'thumb-checked': this.checked } ]})])}
var staticRenderFns = []

export { render, staticRenderFns }